import { render, staticRenderFns } from "./Highlighted.vue?vue&type=template&id=f69b6d12&scoped=true&"
import script from "./Highlighted.vue?vue&type=script&lang=js&"
export * from "./Highlighted.vue?vue&type=script&lang=js&"
import style0 from "./Highlighted.vue?vue&type=style&index=0&id=f69b6d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69b6d12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
